import AV from "leancloud-storage"

var APP_ID = 'KVRpNk2H4f1hGp2U9KE4aFB7-gzGzoHsz';
var APP_KEY = 'nTppiQD0wKfE7eoIxHoOVoK4';
AV.init({
  appId: APP_ID,
  appKey: APP_KEY,

});

export default AV


// WEBPACK FOOTER //
// ./src/lib/leancloud.js